export default function TransferIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.41425 7.00011L17 7.00011V9.00011H8.4143L10 10.5858V12H8.58581L5.29294 8.70723L4.58582 8.00012L5.29293 7.29301L8.58593 4H9.99992L10 4.00011V5.41433L8.41425 7.00011ZM15.5858 15.0001H7.00003V17.0001H15.5858L14 18.5858V20H15.4143L18.7071 16.7072L19.4142 16.0001L18.7071 15.293L15.4141 12H14.0001L14 12.0001V13.4143L15.5858 15.0001Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
